const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const CONSENT_KEY = "fg_analytics_consent";

export const analyticsAvailable = () => Boolean(GA_ID);
export const hasConsent = () => localStorage.getItem(CONSENT_KEY) === "granted";

export function loadAnalytics() {
  if (!GA_ID || window.__fgGaLoaded) return;
  window.__fgGaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

export function trackPage(path) {
  if (window.gtag && hasConsent()) window.gtag("event", "page_view", { page_path: path });
}

export function trackEvent(name, params = {}) {
  if (window.gtag && hasConsent()) window.gtag("event", name, params);
}
